import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  global: {
    fetch: (...args) => {
      return fetch(...args).catch((err) => {
        // Suppress AbortError - these are expected when tabs are throttled
        if (err.name === 'AbortError') {
          return new Response(null, { status: 499 });
        }
        throw err;
      });
    },
  },
});
